const topTop = () => {
  let btnScroll = $(".top-top")

  btnScroll.on("click", function() {
    $('html, body').animate({scrollTop: 0}, 1500);
  })
}

export default topTop;